import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeIconModule, seFeIconSpotFamily } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFePopoverModule } from 'se-fe-popover'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import { SharedUiContactInfoModule } from '@se-po/shared-ui-contact-info'
import { SharedUiDobSelectModule } from '@se-po/shared-ui-dob-select'
import { SharedUiNameModule } from '@se-po/shared-ui-name'
import { SharedUiSetupBarModule } from '@se-po/shared-ui-setup-bar'

import { ParentGuardianInfoComponent } from './parent-guardian-info/parent-guardian-info.component'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiPersonaInfoModule } from '@se-po/shared-ui-persona-info'

@NgModule({
  declarations: [ParentGuardianInfoComponent],
  exports: [ParentGuardianInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeIconModule.include([seFeIconSpotFamily]),
    SeFeLinkModule,
    SeFePopoverModule,
    SeFeSpinnerModule,
    SharedUiContactInfoModule,
    SharedUiDobSelectModule,
    SharedUiHighlightLabelModule,
    SharedUiNameModule,
    SharedUiPersonaInfoModule,
    SharedUiSetupBarModule,
  ]
})
export class SeHouseholdSetupFeatureParentGuardianInfoModule {}
